import { render, staticRenderFns } from "./loadCorrect.vue?vue&type=template&id=7ab735c6"
import script from "./loadCorrect.vue?vue&type=script&lang=js"
export * from "./loadCorrect.vue?vue&type=script&lang=js"
import style0 from "./loadCorrect.vue?vue&type=style&index=0&id=7ab735c6&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports